import type { ObjectDirective } from 'vue';

import { useAuthStore } from '@/entities/auth';

const hasPermission = (permission: string | string[]): boolean => {
  const authStore = useAuthStore();
  return Array.isArray(permission) ? authStore.hasAnyPermission(permission) : authStore.hasPermission(permission);
};

export const vPermission: ObjectDirective<HTMLElement, string | string[]> = {
  mounted(el, binding) {
    if (!hasPermission(binding.value)) {
      el.style.display = 'none';
    }
  },

  updated(el, binding) {
    el.style.display = hasPermission(binding.value) ? '' : 'none';
  },
};
